import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunHandlingFailedAction = {
	type: 'WORKFLOW_RUN_HANDLING_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunHandlingFailedAction => ({
	type: 'WORKFLOW_RUN_HANDLING_FAILED',
	payload,
});
